<template>
  <div class="notification-wrapper">
    <div class="logo-wrapper">
      <img
        srcset="@/modules/user/assets/speaker.png 72w,
                @/modules/user/assets/speaker@2x.png 143w"
        sizes="(max-width: 1365px) 72px,
               143px"
        src="@/modules/user/assets/speaker.png" />
    </div>
    <div class="text-wrapper">
      You have reached your match limit for the month. You will be able to start another match on {{ canMatchDate }}. If you need assistance before that date please contact us at support@lending-well.com
    </div>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: 'MaxDealsNotification',
  props: {
    deals: Array,
  },
  data: () => ({
    canMatchDate: 'XX/XX/XX',
  }),

  watch: {
    deals (newDeals) {
      this.updateCanMatchDate()
    },
  },

  created () {
    this.updateCanMatchDate()
  },

  methods: {
    updateCanMatchDate () {
      this.canMatchDate = moment(this.deals[0].createdAt)
        .add(1, 'month').add(1, 'day')
        .format('MM/DD/YY')
    },
  },
}
</script>

<style lang="scss" scoped>
$mainColor: #CDF2F8;
$innerSpacing: 10px;

.notification-wrapper {
  border: 4px solid $mainColor;
  border-radius: 10px;

  display: flex;
  flex-wrap: nowrap;
  align-items: center;

  margin: 20px 0;
}

.logo-wrapper {
  display: flex;
  align-items: center;
  align-self: stretch;
  padding: $innerSpacing;

  background-color: $mainColor;
}

.text-wrapper {
  padding: $innerSpacing;

  color: #4E4E4E;
  font-family: "Sansation Regular", Serif;
  font-size: 14px;
}
</style>
